/**
 * @file Number validator
 * @author Wim Haanstra
 */
import { Validator } from 'breeze-client';
var NAME_NUMBER_VALIDATOR = 'number';
/**
 * This validator validates that the number value is between MIN and MAX
 */
export function NumberValidator() {
    var name = NAME_NUMBER_VALIDATOR;
    var contxt = {};
    var validator = new Validator(NAME_NUMBER_VALIDATOR, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        var min = 0;
        var max = 0;
        return (value >= min || value <= max);
    }
}
Validator.messageTemplates[NAME_NUMBER_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.NUMBER';
Validator.register(NumberValidator());
